import React, { forwardRef } from 'react';
import './index.scss';
import APIrest from '@api/rest';
import { notifications } from '@utils/notifications';
// import Picture from '@components/Picture';
import { Picture } from '@ui';
import icons from '@icons';
import PropTypes from 'prop-types';
const {
  closeCircle: { darkGrey: closeCircleDarkGrey }
} = icons.Fill;
const {
  plus: { darkRed: plusOutlineDarkRed, darkGrey: plusOutlineDarkGrey },
  camera: { darkGrey: cameraOutlinedarkGrey }
} = icons.Outline;

const Uploader = forwardRef(
  (
    {
      error,
      uploadedPhotos,
      getPhotos,
      uniqueId,
      maximumFilesQuantity = 2,
      className
    },
    ref
  ) => {
    const onUploadImg = e => {
      if (e.target.files.length > 0) {
        const data = new FormData();
        data.append('attachment', e.target.files[0]);
        if (uploadedPhotos.length < maximumFilesQuantity) {
          APIrest.uploadImage(data).then(res => {
            if (res.success && res.data) {
              getPhotos({
                field: 'uploadedPhotos',
                value: [...uploadedPhotos, res.data]
              });
            }
            return res;
          });
        } else {
          notifications(
            `Можно загрузить не более ${maximumFilesQuantity} файлов`,
            'Внимание'
          );
        }
      }
    };

    const deleteFile = (e, id) => {
      e.preventDefault();
      e.stopPropagation();
      const newImages = uploadedPhotos.filter(item => item.id !== id);
      getPhotos({ field: 'uploadedPhotos', value: newImages });
    };

    return (
      <div className={`Uploader ${className || ''}`}>
        <div className='Uploader__icon'>
          <Picture icon={cameraOutlinedarkGrey} height='24' />
        </div>
        {uploadedPhotos.length > 0 &&
          uploadedPhotos.map((item, index) => (
            <div key={item.id} className='Uploader__photo-wrapper'>
              <img className='Uploader__photo' src={item.fileUrl} />
              <Picture
                height='20'
                icon={closeCircleDarkGrey}
                onClick={e => deleteFile(e, item.id)}
                className='Uploader__photo-wrapper__cross'
              />
            </div>
          ))}
        {maximumFilesQuantity !== uploadedPhotos.length && (
          <label
            ref={ref}
            htmlFor={uniqueId}
            className={`Uploader__empty-photo-wrapper${
              error ? ' Uploader__empty-photo-wrapper--error' : ''
            }`}
          >
            <Picture
              className='Uploader__empty-photo'
              icon={error ? plusOutlineDarkRed : plusOutlineDarkGrey}
              height='24'
            />
          </label>
        )}

        <input
          id={uniqueId}
          hidden
          name={uniqueId}
          type='file'
          accept='image/png, image/jpeg, video/*, .heic'
          onChange={onUploadImg}
        />
      </div>
    );
  }
);

Uploader.propTypes = {
  error: PropTypes.bool,
  // functions
  getPhotos: PropTypes.func,
  maximumFilesQuantity: PropTypes.number,
  uniqueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // content
  uploadedPhotos: PropTypes.array
};

export default Uploader;
